// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2hq1T","row":"styles_row__3K_Aa"};